import { useCallback } from 'react';
import { NavigateFunction, useNavigate } from 'react-router';

import { useAppStore } from '../store/app/appStore';

export const useGoBackOrNavigate = () => {
  const navigate = useNavigate();

  const previousPathname = useAppStore((state) => state.previousPathname);

  return useCallback(
    ((to, options) =>
      to === previousPathname ? navigate(-1) : navigate(to, options)) as NavigateFunction,
    [previousPathname],
  );
};
